<template>
  <li role="presentation">
    <form
      class="b-dropdown-form"
      :class="[formClass, { disabled }]"
      :tabindex="disabled ? undefined : '-1'"
      v-bind="$attrs"
      @submit.prevent
    >
      <slot />
    </form>
  </li>
</template>

<script setup lang="ts">
defineOptions({name: 'BDropdownForm', inheritAttrs: false})

defineProps<{
  disabled?: boolean
  formClass?: string | string[] | Record<string, boolean>
}>()
</script>

<style scoped lang="scss">
.b-dropdown-form {
  max-height: 25rem;
  overflow-y: auto;
  padding: .5rem 1rem;
  .form-check {
    padding-top: 0.75rem;
  }
}
</style>
